import React, { FC } from 'react';
import Heading from '../heading';

const CdlPowerSuite: FC = () => {
  return (
    <section>
      <div className="work-item container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="project-title">
              <h3>CDL PowerSuite</h3>
              <h4>An all-in-one FMCSA compliance and training management platform designed for CDL driving schools, motor carriers, and fleet operators to streamline student tracking, ELDT (Entry-Level Driver Training) theory lessons, and Driver Qualification (DQ) file management.</h4>
            </div>
            <p><strong>Role:</strong> Senior Software Engineer - Full Stack</p>
          </div>
          <div className="col-xs-6 col-md-3">
            <p><strong>Technologies Used:</strong></p>
            <ul>
              <li>PostgreSQL / Amazon RDS</li>
              <li>Angular</li>
              <li>TypeScript / JavaScript</li>
              <li>PHP / Laravel</li>
            </ul>
          </div>
          <div className="col-xs-6 col-md-3">
            <p><strong>Cool stuff:</strong></p>
            <ul>
              <li>PWA (Progressive Web App)</li>
              <li>SOC2 Compliance</li>
              <li>AWS S3</li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <p className="text-center"><strong>Check it out in the wild:</strong> <a href="https://www.cdlpowersuite.com/" target="_blank">CDL PowerSuite</a></p>
          </div>
        </div>
        <div className="row center-xs">
          <div className="col-xs-12 col-sm-10">
            <img src="/cdl-powersuite.png" alt="CDL PowerSuite.com" className="featured-project-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CdlPowerSuite;
